import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { Actions as ACTIONS } from '../../store/actions/leaveActions';

import ReactDOM from "react-dom";
// import axios from 'axios';
import Select from 'react-select';
import _ from 'lodash';
import DatePicker from "react-datepicker";
import { TimeInputFormat, DateInputFormat } from "../common/DateComponents";
import "react-datepicker/dist/react-datepicker.css";
import 'react-notifications/lib/notifications.css';
import { format, setHours, setMinutes, setSeconds, setDate, differenceInDays, differenceInMinutes } from 'date-fns'
import { v4 as uuidv4 } from 'uuid';
import { XMarkIcon } from '@heroicons/react/20/solid'
import Spinner from "../common/Spinner";


const CancelLeaveModal = ({
  mode,
  leave,
  leaveType,
  showCancelLeave,
  leaveStatus,

  modalSaving,
  currentLeave,
  saveLeave,
  // mySaveLeave
}) => {

  const [comment, setComment] = useState();

  const clearURLParams = () => {
    urlParams.delete("status");
    urlParams.delete("leaveID");
    window.history.pushState(null, null, `${window.location.pathname}${urlParams.toString() ? "?" : ""}${urlParams.toString()}`);
  }

  const urlParams = new URLSearchParams(window.location.search)
  const urlStatus = urlParams.get('status');
  const urlleaveID = urlParams.get('leaveID');

  if (!leave) return null

  const saveLeaveData = () => {
    leave.comment = comment
    leave.status = leaveStatus

    saveLeave(leave);
    showCancelLeave(null, null);
    setComment(null)
  }

  return (
    <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="block block-themed block-transparent remove-margin-b">
            <div className="block-header bg-danger">
              <ul className="block-options">
                <li>
                  <button type="button" onClick={() => {
                    showCancelLeave(null, null)
                    clearURLParams()
                  }}>
                    <XMarkIcon className="h-6 w-6 mr-3 text-white" />
                  </button>
                </li>
              </ul>
              <h3 className="block-title">{leaveStatus && leaveStatus == "Denied" ? 'Deny' : 'Cancel'} {leaveType} Leave starting {format(new Date(leave.date), "do MMM yyyy")}</h3>
            </div>
            <div className="block-content">

              <div className="form-group">
                <div className="col-sm-12">
                  <label>Add Comment</label>
                  <textarea
                    className="form-control full-width form-input"
                    type="text"
                    name="comment"
                    style={{ minHeight: 100, maxHeight: 400, resize: "vertical" }}
                    onChange={(e) => {
                      setComment(e.target.value)
                    }}
                  >{comment}</textarea>
                  <div className="clearfix" />
                </div>
                <div className="clearfix" />
              </div>

              {comment && !modalSaving &&
                <button
                  className="btn btn-danger pull-right"
                  onClick={() => {
                    saveLeaveData()
                    clearURLParams()
                  }}
                  style={{ marginRight: 0, marginBottom: "20px" }}
                >
                  Cancel Leave
                </button>
              }

              {!comment &&
                <button className="btn btn-warning pull-right" style={{ marginRight: 0, marginBottom: "20px" }}>Add a comment to save</button>
              }

              {
                modalSaving &&
                <button className="btn btn-success pull-right" style={{ marginRight: 0 }}>
                  <Spinner
                    style={{ height: "1.5em", verticalAlign: 'middle', float: "left" }}
                    className="animate-spin -ml-1 mr-3 h-5 w-5 "
                  />
                  <div style={{ float: 'left' }}> Saving </div>
                </button>
              }
              <div className="clearfix" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {

  const {
    // leave,
    leaveTypes,
  } = state.leave



  const leave = state.leave.showCancelLeave;
  const leaveStatus = state.leave.showCancelLeaveStatus;

  return {
    // ...state.my,
    mode: state.mode,
    modalSaving: state.leave.modalSaving,
    leave,
    leaveStatus,
    leaveType: leaveTypes && leave && _.find(leaveTypes, { id: leave.type }).name,

  }
}

const mapDispatchToProps = dispatch => ({
  showCancelLeave: (leave, status) => dispatch(ACTIONS.showCancelLeave(leave, status)),
  saveLeave: (leave) => dispatch(ACTIONS.saveLeave(leave, true)),
  // mySaveLeave: (timesheet) => dispatch(MYACTIONS.mySaveLeave(timesheet)),
  // timesheetUpdateSaveStatus: (status) => dispatch(ACTIONS.timesheetUpdateSaveStatus(status))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CancelLeaveModal) 
